module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/contentful/~/axios/index.js
// module id = 480
// module chunks = 1